import { VINTED_LOCALE_TO_ISO_MAP } from 'constants/language';
import { stateName } from './constants';

const validLocale = locale => VINTED_LOCALE_TO_ISO_MAP[locale] || locale;

const localState = state => state[stateName];

export const getMessages = state => localState(state).messages;
export const getLocale = state => validLocale(localState(state).locale);